import React from 'react';

function noop() {}

export function ConfirmationDialog({
    message,
    confirmLabel,
    cancelLabel,
    onConfirm,
    onCancel,
}) {
    return (
        <div
            className="sylius-validation-error product__lightbox"
            id="sylius-cart-validation-error"
        >
            {message}
            <div className="pt-6">
                <button onClick={onCancel || noop} className="btn btn--primary">
                    {cancelLabel}
                </button>
                <button
                    onClick={onConfirm || noop}
                    className="btn btn--secondary"
                >
                    {confirmLabel}
                </button>
            </div>
        </div>
    );
}
